import { getEnvironment } from "mt-shared/environment";

export const magicalTripLink = {
  local: "http://localhost:3000",
  staging: "https://staging.magical-trip.com",
  production: "https://www.magical-trip.com",
}[getEnvironment()];
